<template>     
    <div class="home">   
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Resumen
          <v-btn icon @click="deleteDocument">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-layout wrap align-center>            
            <v-flex xs10 offset-xs1 mb-3>
              <TimeTable/>
            </v-flex>
            <v-flex xs10 offset-xs1 mb-3>
                <v-checkbox
                    v-if="this.$store.state.relation == ''"
                    v-model="custSignature"
                    label="Incluir firma de cliente"
                ></v-checkbox>
                <v-layout v-if="custSignature" wrap>
                    <v-flex xs12 md6 xl3><span class="bold">Fecha: </span>{{ new Date(this.$store.state.fechaParte).toLocaleDateString("es-ES")}}</v-flex>
                    <v-flex xs12 md6 xl3><span class="bold">Vehículo: </span>{{this.resourcesInLines}}</v-flex>
                    <v-flex xs12 md6 xl3><span class="bold">Origen: </span>{{this.$store.state.origen}} 
                    <span class="bold">Destino: </span>{{this.$store.state.destino}}</v-flex>
                    <v-flex xs12 md6 xl3><span class="bold">Horario: </span>{{this.hoursInLines}}</v-flex>
                    <v-flex xs12 md6 xl3><span class="bold">Operarios: </span>{{this.operarios}}</v-flex>
                    <v-flex xs12 md6 xl3 v-if="lineTaskDescriptions+taskDescription != ''"><span class="bold">Desc. Tarea: </span>{{lineTaskDescriptions+taskDescription}}</v-flex>
                </v-layout>
                <v-tabs :show-arrows="false" v-model="tab" grow dense v-if="$store.state.driver">
                    <v-tab>Operario</v-tab>
                    <v-tab v-if="(this.$store.state.relation == '') && custSignature">Cliente</v-tab>
                    <v-tab>Acept. Servicios</v-tab>
                    <v-tab>Fotos</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab" v-if="$store.state.driver">
                    <v-tab-item>
                        <div style="display: flex; justify-content: center;">
                            <SignaturePad :type="'op'"/>
                        </div>
                    </v-tab-item>
                    <v-tab-item  v-if="(this.$store.state.relation == '') && custSignature">
                        <div style="display: flex; justify-content: center;">
                            <SignaturePad :type="'cust'"/>        
                        </div>
                    </v-tab-item>
                    <v-tab-item>
                        <div style="display: flex; justify-content: center;">
                            <SignaturePad :type="'serv'"/>
                        </div>
                    </v-tab-item>
                    <v-tab-item>
                        <Uploader/>
                    </v-tab-item>
                </v-tabs-items>
            </v-flex>
        </v-layout>  
        <br>    
        <br>
        <br>
        <br>
        <br>          
        <v-divider></v-divider>       
        <v-footer absolute padless>
            <v-flex v-if="alert" xs10 offset-xs1 mb-3>
                <v-alert
                    dense
                    type="error"
                    >
                    <span class="alertContent">{{alertContent}}</span>
                </v-alert>
           </v-flex>
           <v-flex xs10 offset-xs1 v-if="forceMandatoryFields || taskDescription != ''">   
                <v-textarea
                v-model="taskDescription"
                autocomplete="off"
                @keyup="checkLength(250)"
                >
                <template v-slot:label>
                    <div>
                    Descripción de la tarea <small>(obligatorio)</small>
                    </div>
                </template>
                </v-textarea>  
            </v-flex>    
            <!--v-flex xs8 offset-xs2 mb-5>
              <v-btn block color="warning" dark @click="openCustomerSignatureDialog">Firma Cliente</v-btn>
            </v-flex-->
            <v-flex xs8 offset-xs2 mb-5>
              <v-btn block color="warning" :loading="isLoading" dark @click="back">Volver</v-btn>
            </v-flex> 
            <v-flex xs8 offset-xs2 mb-5>
              <v-btn block color="success" :loading="isLoading" dark @click="checkAndCreate">Finalizar</v-btn>
            </v-flex>        
        </v-footer> 
    </div>
</template>
<script>

import TimeTable from '@/components/TimeTable.vue'
import SignaturePad from '@/components/SignaturePad.vue'
import Uploader from '@/components/ImageUploader.vue'
import store from '../store';

export default {
    name: 'ResumenSignature',
    components:{
      TimeTable,
      SignaturePad,
      Uploader
    },
    data () {
        return {    
            tab : 0,
            custSignature: true,
            alert: false,
            alertContent: '',
            forceMandatoryFields: false
        }
    },
    methods:{
        back(){
            this.$router.go(-1);
        },
        close(){
            this.dialog = false;                        
        },
        closeOK(){            
            this.dialog = false;                        
        },        
        checkAndCreate(){
            console.log(this.lineTaskDescriptions);
            console.log(this.taskDescription);
            console.log(this.hoursInLines);
            if ((this.lineTaskDescriptions == '') && (this.taskDescription == '') && (this.hoursInLines != ' - ')){
                this.alertContent = 'Debe rellenar la descripción de la tarea';
                this.alert = true;
                this.forceMandatoryFields = true;
                var thisaux = this; 
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            } 
            this.createDocument();
        }   ,  
        openCustomerSignatureDialog(){
          store.state.dialogSignatureCustomer = true;
        },
        deleteDocument(){
          store.commit('resetDataAfterSuccessfulCreation');
        },
        checkLength(max){
            if (this.taskDescription.length > max){
                this.taskDescription = this.taskDescription.slice(0,max);
            }
        },
    },
    mounted(){
        /*if ((store.state.workTypes == undefined) || (store.state.workTypes.length == 0))
            this.getWorkTypes();*/
    }, 
    watch:{      
    },
    computed:{
        lineTaskDescriptions: {
            get(){
                var lines = this.$store.state.lineasParte.filter(lin => (lin.taskDescription != ''));
                var res = '';
                lines.forEach(lin => {
                    if (res != '') res += ' - ';
                    res += lin.taskDescription
                });
                return res;
            }      
        },
        dialog: {
            get(){
                return this.$store.state.dialogSignature;
            },
            set(value){
                this.$store.state.dialogSignature = value;
            }
        },
        proyectos:{
            get(){
                return this.$store.state.jobs;
            }
        },
        tareas:{
            get(){
                return this.$store.state.jobTasks;
            }
        },
        proyecto:{
            get(){
                return this.$store.state.proyecto;                
            }/*,
            set(value){
                this.$store.state.proyecto = value;
            }*/
        },
        proyectoFullName:{
            get(){
                var jobno = this.$store.state.proyecto;
                var fullname = '';
                if (jobno != ''){
                  var res = this.$store.state.proyectos.find(job =>{
                    return job.no == jobno;
                  });
                  console.log(res);
                }
                return fullname;
            }
        },
        tarea:{
            get(){
                return this.$store.state.tarea;
            }/*,
            set(value){
                this.$store.state.tarea = value;
            }*/
        },
        images:{
            get(){
                return this.$store.state.images;
            },
            set(value){
                this.$store.state.images = value;
            }
        },
        isLoading:{
            get(){
                return this.$store.state.isLoading;
            }
        },
        resourcesInLines:{
            get(){
                var res = "";
                this.$store.state.lineasParte.forEach(line => {
                    if (line.startTimeInvoiceable != undefined){
                        if (res != '') res += ', ';
                        if (line.resource != '') res += line.resource;
                    }
                });
                return res;
            }
        },
        hoursInLines:{
            get(){
                var start = 2400;
                var startStr = '';
                var end = 0;
                var endStr = '';
                var timeToInt = '';
                this.$store.state.lineasParte.forEach(line => {
                    if ((line.invoiceableTimeCount != 0) && (line.workType != '')){
                        /*var lineWorktype = store.state.workTypes.find(wt => (wt.code == line.workType));
                        if (!lineWorktype.extra){*/
                            if ((line.startTimeInvoiceable != undefined) && (line.invoiceableTimeCountUom != '')){
                                timeToInt = line.startTimeInvoiceable.replace(':','');
                                if (Number(timeToInt) < start) {
                                    start = timeToInt;
                                    startStr = line.startTimeInvoiceable;
                                }
                            }
                            if ((line.endTimeInvoiceable != undefined) && (line.invoiceableTimeCountUom != '')){
                                timeToInt = line.endTimeInvoiceable.replace(':','');
                                if (Number(timeToInt) > end){
                                    end = timeToInt;
                                    endStr = line.endTimeInvoiceable;
                                }
                            }
                        //}
                    }
                });
                return startStr + " - " + endStr;
            }
        },
        operarios:{
            get(){
                var res = "";
                this.$store.state.user.forEach(usr => {
                    console.log(usr)
                    var userData = this.$store.state.users.find(u =>{
                        return u.User == usr;
                    })
                    console.log(userData);
                    if (res != '') res += ', ';
                    res += userData.Name;
                });
                return res;
            }
        },
        taskDescription:{
            get(){
                return this.$store.state.taskDescription;
            },
            set(value){                
                this.$store.commit('saveTaskDescription',value);
            }
        },
    }
}
</script>
<style>
.bold{
    font-weight: bold;
}
</style>
